export interface CustomerEmployee {
  id: string
  name: string
  vatNumber?: string
  businessName?: string
  address?: string
  postCode?: string
  city?: string
  state?: string
  country?: string
}

export interface CompanyEmployee {
  id: string
  name: string // Nombre comercial
  role: Role
  inactive: boolean
  externalCustomer?: CustomerEmployee
}

export default interface Employee {
  id: string
  name: string
  surname: string
  email: string
  phoneNumber: string
  nif: string
  companies: CompanyEmployee[]

  deliveryNotesCount: number
  workingDaysCount: number
}

export interface EmployeeResponse {
  employees: Employee[]
}

export interface EmployeeRequest {
  id: string
  name: string
  surname: string
  email: string
  phoneNumber: string
  nif: string
  role: Role
  inactive?: boolean
  externalCustomerId?: string
}

export interface EmployeeEmailUpdateRequest {
  email: string
}

export enum Role {
  ADMIN = 'ADMIN',
  DRIVER = 'DRIVER'
}
